import { PARTICIPANTS_CATEGORIES } from 'constants/participants'
import { FindMissingBirthdateInAllCategories } from './types/findMissingBirthdateInAllCategories.types'
import { findBirthdateIndexInCategoryList } from './'

export const findMissingBirthdateInAllCategories: FindMissingBirthdateInAllCategories = (
  seekedBirthdate,
  birthdates,
  excludedCategory
) => {
  const { birthdate, source } = seekedBirthdate

  for (let idx = 0; idx < PARTICIPANTS_CATEGORIES.length; idx++) {
    const category = PARTICIPANTS_CATEGORIES[idx]

    if (category !== excludedCategory) {
      const foundIndex = findBirthdateIndexInCategoryList(birthdate, birthdates[category])

      if (foundIndex !== -1) {
        return { destination: category, index: foundIndex }
      }
    }
    if (idx + 1 === PARTICIPANTS_CATEGORIES.length) {
      return { birthdate, destination: null, source }
    }
  }
}
